/* header-flyouts.js — panels under the header icon cluster (Athlete2
 * pattern): account dropdown + project sidebar drawer. The CART uses the
 * theme's cart-drawer section (SSR lines, shipping-promise bar, Section
 * Rendering refresh — see theme.js); here we only add hover-open for it.
 * Hover (fine pointers) or click opens; outside click / Esc /
 * pointer-leave closes. Icons keep their hrefs, so with no JS they stay
 * plain links.
 */
(() => {
  'use strict';
  const header = document.querySelector('.site-header');
  if (!header) return;
  const toggles = [...header.querySelectorAll('[data-flyout-toggle]')];
  const panel = (name) => header.querySelector('[data-flyout="' + name + '"]');
  const finePointer = matchMedia('(pointer:fine)');

  let openName = null;
  let hoverTimer = null;

  function setExpanded(name, on) {
    const t = header.querySelector('[data-flyout-toggle="' + name + '"]');
    if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (t) t.classList.toggle('is-open', on);
  }
  function close() {
    if (!openName) return;
    const p = panel(openName);
    if (p) p.hidden = true;
    setExpanded(openName, false);
    openName = null;
  }
  let openedAt = 0;
  function open(name) {
    if (openName === name) return;
    close();
    const p = panel(name);
    if (!p) return;
    p.hidden = false;
    setExpanded(name, true);
    openName = name;
    openedAt = Date.now();
  }

  // click always OPENS — hover may have opened the panel milliseconds
  // earlier, and a hover-then-click that toggled would slam it shut in the
  // user's face. Closing is outside click / Esc / pointer-leave / × only.
  toggles.forEach((t) => {
    t.addEventListener('click', (e) => {
      e.preventDefault();
      open(t.dataset.flyoutToggle);
    });
  });

  // hover open/close with grace timers (desktop pointers only).
  // The CART is click-only (A-2 pattern) — no hover-open for it.
  // a closing full-overlay drawer uncovers the header under the cursor —
  // the resulting synthetic pointerover must not hover-reopen what the
  // user just closed
  let lastDrawerClose = 0;
  document.addEventListener('drawer:closed', () => { lastDrawerClose = Date.now(); });
  header.addEventListener('pointerover', (e) => {
    if (!finePointer.matches) return;
    if (Date.now() - lastDrawerClose < 450) return;
    clearTimeout(hoverTimer);
    // drawers (cart, project) are click-only for consistency — hover-open
    // remains only for the account dropdown
    const t = e.target.closest('[data-flyout-toggle="account"]');
    if (t) hoverTimer = setTimeout(() => open(t.dataset.flyoutToggle), 120);
  });
  header.addEventListener('pointerout', (e) => {
    if (!finePointer.matches) return;
    clearTimeout(hoverTimer);
    if (openName !== 'account') return; // click-opened drawers stay put until dismissed
    const to = e.relatedTarget;
    if (to && to.closest && (to.closest('[data-flyout]') || to.closest('[data-flyout-toggle]'))) return;
    hoverTimer = setTimeout(close, 250);
  });

  document.addEventListener('click', (e) => {
    if (!openName) return;
    // a panel opened programmatically during THIS click (e.g. save-to-project)
    // must not be immediately closed by the same click bubbling here
    if (Date.now() - openedAt < 80) return;
    // in-panel clicks often re-render the panel before this handler runs —
    // a detached target can't prove it was outside, so never close on it
    if (!e.target.isConnected) return;
    if (e.target.closest('[data-flyout]') || e.target.closest('[data-flyout-toggle]')) {
      if (e.target.closest('[data-flyout-close]')) { close(); lastDrawerClose = Date.now(); }
      return;
    }
    close();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { close(); lastDrawerClose = Date.now(); }
  });
  // programmatic open for other islands (project-list.js) — avoids synthetic
  // toggle clicks racing the outside-click / hover-close logic
  document.addEventListener('flyout:open', (e) => {
    if (e.detail) open(String(e.detail));
  });
})();
